import { GridApi } from 'ag-grid-community';
import { RoleSelect } from 'components/selects/RoleSelect';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'role.roleId' as const;

/**
 * Parameters of the RoleSelectFilter component.
 */
export interface RoleSelectFilterProps {
  api: GridApi;
  onChange?: FilterChangeCallback;
}

/**
 * Filter component for the role column.
 *
 * This filter assumes:
 *   - column field is `role.roleId`
 */
export default function RoleSelectFilter({ api, onChange }: RoleSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <RoleSelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky role"
      value={String(value)}
      onChange={setValue}
    />
  );
}
